import _ from 'lodash';
import ApiColumn from './ApiColumn';
import ApiSummaryColumn from './ApiSummaryColumn';

export class ApiMetadata {
  /**
   * @var {ApiColumn[]}
   */
  columns;

  /**
   * @param model
   * @param isSummary
   */
  constructor(model = {}, isSummary = false) {
    this.columns = _.map(model.columns || [], (column) =>
      isSummary ? new ApiSummaryColumn(column) : new ApiColumn(column)
    );
  }
}

export default ApiMetadata;
